// index 가 아니라 paths 를 직접 읽는다 — index 는 이 파일을 재노출하므로 순환 import 가 된다.
import { storeCustomizePath } from './paths';

/** 가입 뒤 남은 인증(이메일·본인인증)을 마치는 화면 — 인증 전 계정의 거절 안내가 여기로 보낸다. */
export const ONBOARDING_PATH = '/onboarding';

/** 마이페이지 하위 화면 — 홈(/my)·내 견적(/my/quotes)과 함께 마이페이지 메뉴를 이룬다. */
export const MY_DESIGNS_PATH = '/my/designs';
export const MY_PROFILE_PATH = '/my/profile';
export const MY_WITHDRAW_PATH = '/my/withdraw';
/** 탈퇴를 마친 뒤 가는 공개 안내 화면 — 세션이 없어도 열려야 해서 마이페이지 밖에 둔다. */
export const WITHDRAWN_PATH = '/withdrawn';

/** 커스터마이징 화면이 이어서 열 저장 디자인을 읽는 쿼리 이름(pages/customize 와 같은 값). */
export const CUSTOMIZE_DESIGN_PARAM = 'designId';

/** 저장한 디자인을 이어서 편집하는 주소 — /store/:productId/customize?designId=. */
export const storeCustomizeDesignPath = (productId: string, designId: string): string =>
  `${storeCustomizePath(productId)}?${CUSTOMIZE_DESIGN_PARAM}=${encodeURIComponent(designId)}`;
